import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import RightArrow from '@/images/arrows/RightArrow.svg';
import { App } from '@/pages/apps/AppsPage';
import styled from '@emotion/styled';
import { ButtonBase } from '@mui/material';

const Button = styled(ButtonBase)`
    display: flex;
    margin-right: auto;

    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    gap: 20px;
    transition: gap 0.3s ease-in-out;
`;

const Container = styled.div<{ onClick?: any }>`
    display: flex;
    flex-direction: column;
    padding: 24px;
    height: 330px;
    width: 300px;
    gap: 16px;
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.black[300]};
    background: white;
    cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};

    :hover {
        border: 1px solid ${({ theme }) => theme.colors.primary[900]};
        box-shadow:
            0.3px 0.8px 1.1px 0px rgba(187, 187, 187, 0.11),
            0.5px 1.3px 1.8px -0.6px rgba(187, 187, 187, 0.18),
            1.1px 2.7px 3.8px -1.2px rgba(187, 187, 187, 0.26);

        ${Button} {
            color: ${({ theme }) => theme.colors.primary[900]};
            gap: 24px;
        }
    }
`;

const ImageContainer = styled.div`
    height: 56px;
`;

const Image = styled.img`
    max-width: 120px;
    height: 56px;
`;

const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const Label = styled.span`
    color: ${({ theme }) => theme.colors.secondary[900]};
    font-size: 18px;
    font-weight: 800;
    line-height: 27px;
`;

const Description = styled.span`
    color: ${({ theme }) => theme.colors.black[700]};
    font-size: 16px;
    font-weight: 400;
    line-height: 21px;
`;

const ActionWrapper = styled.div`
    margin-top: auto;
`;

interface Props {
    app: App;
}

export const AppButton = ({ app }: Props) => {
    return (
        <Container id={app.id} onClick={app.onClick}>
            <ImageContainer>
                <Image src={app.icon} />
            </ImageContainer>

            <TextContainer>
                <Label>{app.label}</Label>

                <Description>{app.description}</Description>
            </TextContainer>

            <ActionWrapper>
                {app.children}
                {!app.children && (
                    <Button>
                        Try for free
                        <MaskedIcon src={RightArrow} size="16px" />
                    </Button>
                )}
            </ActionWrapper>
        </Container>
    );
};
